module.exports = __webpack_public_path__ + "static/media/modal-background.7ab2fc81.png";